var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDonation = function SvgDonation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9,
    d: "M30.889 23.111c2.318-2.271 4.667-4.993 4.667-8.555A8.555 8.555 0 0 0 27 6c-2.738 0-4.667.778-7 3.111C17.667 6.778 15.738 6 13 6a8.556 8.556 0 0 0-8.556 8.556c0 3.577 2.334 6.3 4.667 8.555L20 34z"
  })));
};
export default SvgDonation;